export const PUBLIC_ROUTES = [
  '/auth/login',
  '/auth/register',
  '/auth/accept-invitation',
  '/auth/forgot-password',
  '/auth/reset-password',
  '/auth/callback'
];
